import { stickersEnabled } from "@/src/services/api/posts/engagement-functions";
import { useOrgFeature } from "@/src/services/organization/org-features.hooks";

/**
 * Stickers are shown (and the Sticker button offered) only when this build has
 * the stickers Function configured AND the org has not switched them off.
 * The org switch is read straight from the org's `organizationconfig` row;
 * while that read is pending nothing sticker-related is shown.
 */
export const useStickersOn = (): boolean => {
  const { enabled } = useOrgFeature("stickers");
  return stickersEnabled && enabled;
};
